import { render, staticRenderFns } from "./EquipmentCreation.vue?vue&type=template&id=5b85c213&scoped=true&"
import script from "./EquipmentCreation.vue?vue&type=script&lang=js&"
export * from "./EquipmentCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b85c213",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b85c213')) {
      api.createRecord('5b85c213', component.options)
    } else {
      api.reload('5b85c213', component.options)
    }
    module.hot.accept("./EquipmentCreation.vue?vue&type=template&id=5b85c213&scoped=true&", function () {
      api.rerender('5b85c213', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipments/EquipmentCreation.vue"
export default component.exports